import { RowValidState } from "./RowValidState";

export class TableValidState {
  /**
   * @type {Map<any, RowValidState>}
   */
  public rowMap: Map<any, RowValidState> = new Map();
  /**
   * hat die Table keinen direkten Fehler?
   */
  public valid: boolean = true;
  /**
   * hat die Table keinen transitiven Fehler?
   */
  public transValid: boolean = true;
}
